<template>
    <div :class="['page campaign',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content rating">
            <div v-if="campaign">
                <h2 style="text-align: center;margin: 20px;font-weight: 400;">{{ campaign.title }}</h2>
                <div v-if="!rating">
                    <p v-for="page in campaign.pages.filter(p => p.clientShare)" @click="showPage(page)" class="btn">{{ page.field }}</p>
                </div>
                <div v-if="rating">
                    <img :src="starLink" style="width: 90%; margin: 5%" />
                    <img v-if="timeLine" :src="timeLine" style="width: 90%;margin: 5%;" />
                    <p class="btn" @click="showReviews()">reviews</p>
                </div>
            </div>
        </div>
        <Reviews v-if="pages.indexOf('review') > -1" :campaign="campaign" />  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import Reviews from '@/components/Reviews.vue'

export default {
    props: ['campaign_id'],
    name: 'client-campaign',
    components: {
        VHeader,
        Reviews
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        pages () { return this.$store.state.pages },
        clientCampaigns () { return this.$store.state.clientCampaigns }
    },
    data () {
        return {
            campaign: false,
            rating: false,
            starLink: '',
            timeLine: '',
            review: false
        }
    },
    created () {
        this.campaign_id && ( this.timeLine = `https://api.survey-vip.com/time-line/${this.campaign_id}/day/900/470` ); 
    },
    mounted () {
        WebSoc.SEND({ t: 'getCampaign', data: { auth: this.auth, campaign_id: this.campaign_id }},campaign => {
           
            campaign.pages = campaign.pages.filter(p => p.field);
            this.campaign = campaign;
            if ( campaign.ratingSummary ) return this.showRating(campaign);
            this.rating = false;
            this.$nextTick(() => {
                [].slice.call(this.$el.querySelectorAll('.campaign p.btn')).forEach(btn =>  parseInt(getComputedStyle(btn).height) > 50 && ( btn.style.lineHeight = 1.5 ));
            })
        });
    },
    methods: {
        showRating ( campaign ) {
            this.rating = true;
            this.starLink = campaign.ratingStarLinks.find(l => l.title == 'Star Link').url;
        },
        showReviews () {
            this.pushPage('review');
        },
        showPage ( page ) {
            console.log('showPage',page);
        },
        back () {
            this.pageOn = false;
            setTimeout(() => {
               this.popPage('client-campaign');
            },200);
        },
        ...mapMutations(['pushPage','popPage'])
    }
}

</script>

<style>

</style>